import {checkTypeFileImage} from "./checkTypeFileUpload";

export function readFileImage() {
    let that = this,
        $that = $(that),
        checkType = checkTypeFileImage(that),
        img = $('#' + $that.attr('id') + '_view');
    if($that.val()){
        if (that.files && that.files[0]) {
            let reader = new FileReader();
            reader.readAsDataURL(that.files[0]);
            reader.onload = function (e) {
                if (checkType){
                    img.attr('src', e.target.result);
                }else {
                    img.attr('src', '../../images/user-none.png');
                }
            };
        }
    }else {
        img.attr('src', '../../images/user-none.png');
    }
}